import React from "react";
import { Form, Col, Row } from "react-bootstrap";

function InputContainer({
  children,
  label,
  colSize,
  style,
  labelSize,
  onLabelClick = null,
  labelClassName,
  rowStyle,
  ignoreColPadding = false,
  required = false,
  stacked = false,
}) {
  return (
    <div style={{ ...style }}>
      <Form.Group
        as={Row}
        style={{
          alignItems: stacked ? "flex-start" : "center",
          flexDirection: stacked ? "column" : "row",
          marginBottom: "0.5rem",
          ...rowStyle,
        }}
      >
        {label && (
          <Form.Label
            className={`${labelClassName ?? "pl-4 d-flex"}`}
            column
            sm={"12"}
            md={stacked ? "12" : (labelSize || "2")}
            xs={"12"}
            style={{
              paddingTop: "0px",
              paddingRight: "0px",
              paddingBottom: stacked ? "2px" : "0px",
              wordBreak: "break-word",
              cursor: `${onLabelClick ? "pointer" : "default"}`,
            }}
            onClick={onLabelClick}
          >
            {label}
            {required && (
              <span style={{ color: "red", marginLeft: "4px", fontWeight: "bold" }}>
                *
              </span>
            )}
          </Form.Label>
        )}
        {!ignoreColPadding ? (
          <Col sm={"12"} md={stacked ? "12" : (colSize || "8")} xs={"12"} className="pr-10">
            {children}
          </Col>
        ) : (
          children
        )}
      </Form.Group>
    </div>
  );
}

export default InputContainer;
